// ./pages/About/index.jsx
import React from "react";
import Shopsubbanner from "../../components/shopsubbanner";
import Privacypolicy from "../../components/privacypolicy";

const Privacy = () => {
  return (
    <>
      <Shopsubbanner
        title="Privacy Policy"
        image_url="https://res.cloudinary.com/dtivafy25/image/upload/v1749818243/Derby_01_ghbhas.jpg" />
      <Privacypolicy />
    </>
  );
};

export default Privacy;
